import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 485.000000 514.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,514.000000) scale(0.100000,-0.100000)" >


<path d="M2264 3496 c-34 -7 -88 -28 -120 -47 -79 -46 -181 -151 -223 -228
l-33 -62 48 3 c47 3 48 4 83 63 88 153 261 263 415 266 46 1 55 3 36 9 -37 12
-136 10 -206 -4z"/>
<path d="M2260 3274 c-32 -11 -96 -39 -109 -49 -29 -22 -91 -82 -91 -89 0 -4
-9 -19 -20 -33 -31 -40 -26 -53 20 -53 34 0 42 4 55 31 40 76 125 146 219 179
l51 19 -55 -1 c-30 0 -62 -2 -70 -4z"/>
<path d="M2925 3215 l-30 -25 46 0 c42 0 79 20 79 43 0 17 -68 4 -95 -18z"/>
<path d="M1651 3182 c-7 -13 -10 -180 -8 -478 l2 -459 98 0 97 0 1 283 c1 175
6 285 12 289 8 5 36 -22 74 -72 65 -83 78 -101 84 -105 3 -3 37 -45 74 -95 37
-49 72 -95 79 -100 6 -6 16 -19 22 -30 6 -10 15 -20 20 -22 6 -2 39 19 74 47
66 50 90 60 90 38 1 -7 2 -59 3 -116 2 -79 5 -105 17 -112 20 -13 424 -12 480
1 246 57 396 302 346 567 -20 108 -55 176 -125 246 l-59 58 -59 -48 c-32 -27
-70 -57 -83 -67 -16 -11 -21 -20 -13 -23 48 -21 97 -71 119 -120 33 -74 38
-121 25 -201 -15 -88 -62 -161 -128 -200 -43 -25 -57 -28 -171 -31 -76 -3
-127 -1 -134 6 -6 6 -9 68 -9 156 2 106 -1 146 -10 146 -6 0 -28 -15 -48 -32
-21 -18 -55 -46 -76 -63 -22 -16 -54 -42 -71 -57 -34 -30 -69 -36 -77 -15 -4
12 -134 186 -146 197 -3 3 -10 12 -16 21 -8 14 -165 221 -236 312 -12 15 -29
42 -38 60 l-16 32 -92 3 c-82 2 -93 1 -102 -16z m1359 -652 c0 -5 -5 -10 -11
-10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z"/>
<path d="M2755 3081 l-40 -26 37 -3 c25 -2 46 3 63 15 59 43 4 56 -60 14z"/>
<path d="M2276 3053 c-33 -5 -44 -13 -98 -67 -43 -45 -39 -61 16 -51 25 5 41
16 53 35 9 15 33 39 54 51 58 36 52 43 -25 32z"/>
<path d="M2593 2957 c-43 -29 -41 -39 5 -31 36 6 72 29 72 46 0 15 -45 7 -77
-15z"/>
<path d="M2481 2794 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2434 2745 c-9 -20 -25 -40 -35 -46 -33 -17 -22 -30 19 -23 47 8 59
18 67 56 5 21 3 33 -6 39 -22 14 -27 11 -45 -26z"/>
<path d="M1750 1973 c0 -15 2 -16 10 -3 6 10 10 11 10 3 0 -7 5 -13 10 -13 6
0 10 7 10 15 0 8 -9 15 -20 15 -12 0 -20 -7 -20 -17z"/>
<path d="M810 1800 c0 -163 1 -170 20 -170 19 0 20 7 20 113 0 128 10 160 30
95 7 -24 14 -59 17 -78 10 -85 25 -130 43 -130 20 0 26 12 35 75 13 87 28 155
35 155 9 0 20 -104 15 -142 -2 -16 0 -28 4 -28 4 0 6 -13 3 -29 -3 -24 -1 -29
14 -27 18 3 19 16 22 169 l2 167 -44 0 c-43 0 -44 -1 -49 -37 -4 -21 -10 -66
-16 -101 -5 -35 -12 -66 -16 -70 -11 -11 -25 21 -25 59 0 20 -5 61 -11 92
l-12 57 -43 0 -44 0 0 -170z"/>
<path d="M1535 1948 c-3 -13 -4 -88 -2 -168 l2 -145 25 0 c29 0 27 -8 29 135
1 110 1 110 26 110 30 0 38 -34 31 -136 -6 -87 0 -114 25 -114 18 0 19 9 19
126 0 143 -7 167 -48 158 -15 -4 -33 -11 -39 -17 -10 -7 -13 -3 -13 16 0 38
-10 57 -31 57 -11 0 -21 -9 -24 -22z"/>
<path d="M1953 1948 c8 -31 -4 -50 -23 -38 -18 12 -41 12 -57 2 -37 -24 -37
-238 -1 -274 19 -19 21 -19 38 -3 13 11 26 15 37 10 10 -4 26 -9 36 -10 19 -2
20 2 19 210 l-1 120 -27 3 c-23 3 -26 1 -21 -20z m-1 -95 c8 -45 1 -174 -9
-184 -18 -18 -40 2 -47 39 -10 61 -7 147 6 160 21 21 45 14 50 -15z"/>
<path d="M2760 1806 c0 -187 -1 -184 86 -171 58 8 62 20 63 173 1 149 -6 162
-94 162 l-55 0 0 -164z m97 94 c4 -16 7 -72 5 -124 -3 -75 -7 -96 -19 -101
-31 -11 -38 13 -36 126 1 60 5 114 8 119 12 20 35 9 42 -20z"/>
<path d="M3180 1945 c0 -14 -6 -34 -12 -45 -9 -15 -10 -23 -2 -28 6 -4 12 -50
13 -111 2 -106 10 -131 41 -131 23 0 32 11 20 25 -15 18 -15 187 0 214 8 17 9
26 1 34 -6 6 -11 24 -11 39 0 23 -4 28 -25 28 -20 0 -25 -5 -25 -25z"/>
<path d="M3517 1953 c-8 -10 -18 -34 -22 -53 -6 -33 -2 -41 49 -98 57 -64 69
-99 42 -121 -22 -18 -46 -2 -46 31 0 25 -4 29 -22 26 -20 -3 -23 -8 -20 -38 3
-49 35 -74 85 -67 21 3 41 8 44 11 12 11 21 91 12 101 -5 5 -9 16 -9 25 0 9
-20 36 -45 60 -34 33 -45 51 -43 70 4 32 37 40 45 11 3 -14 13 -21 29 -21 26
0 27 3 18 36 -11 41 -88 58 -117 27z"/>
<path d="M3898 1918 c-2 -29 -2 -103 0 -164 3 -105 5 -112 25 -118 26 -6 49
11 42 33 -2 9 -6 56 -6 105 -2 76 1 91 16 102 16 12 20 11 33 -7 18 -27 8
-182 -14 -200 -20 -16 -18 -27 7 -34 13 -4 27 0 40 11 17 15 19 31 19 129 0
97 -2 114 -19 129 -10 10 -22 13 -25 8 -3 -5 -16 -7 -30 -5 -17 4 -26 13 -30
34 -4 23 -11 29 -30 29 -23 0 -25 -4 -28 -52z"/>
<path d="M1145 1896 c-14 -14 -25 -29 -25 -33 0 -17 44 -11 57 7 8 11 20 17
28 14 11 -5 14 -30 13 -120 -2 -119 5 -140 38 -127 22 9 30 73 11 85 -8 4 -8
10 0 20 15 19 9 136 -8 152 -8 8 -31 17 -52 20 -31 6 -41 3 -62 -18z"/>
<path d="M1380 1912 c-27 -4 -52 -31 -45 -49 2 -7 0 -15 -5 -18 -14 -8 -12
-119 1 -165 25 -84 149 -64 149 24 0 32 -3 36 -26 36 -21 0 -25 -4 -23 -22 2
-13 -5 -36 -14 -53 -10 -19 -16 -24 -17 -13 0 9 -5 18 -10 20 -6 2 -13 47 -16
100 -5 92 -4 97 16 108 28 15 44 1 45 -38 0 -20 6 -28 23 -30 20 -3 22 1 22
37 0 22 -5 43 -10 46 -20 12 -65 21 -90 17z"/>
<path d="M1752 1911 c-19 -12 -14 -271 6 -278 30 -12 37 17 35 142 -2 144 -6
159 -41 136z"/>
<path d="M2120 1912 c-42 -4 -60 -18 -60 -43 0 -23 38 -26 46 -4 6 15 43 21
45 8 0 -5 2 -20 4 -35 3 -24 -2 -29 -40 -44 -52 -19 -68 -54 -57 -119 7 -36
10 -40 36 -40 16 0 31 6 34 14 3 9 -2 11 -19 7 -13 -3 -19 -3 -13 -1 6 4 9 26
6 59 -4 48 -2 55 18 66 12 6 24 9 27 6 3 -3 6 -38 7 -78 1 -71 2 -73 26 -73
l25 0 3 118 c4 121 -1 139 -37 155 -9 4 -32 6 -51 4z"/>
<path d="M2265 1837 c4 -45 13 -109 19 -141 11 -53 15 -60 38 -63 29 -4 30 -1
43 100 6 48 20 61 29 30 5 -19 19 -101 20 -118 1 -13 45 -15 52 -3 6 10 34
218 34 256 0 12 -3 22 -7 22 -21 -1 -34 -21 -38 -58 -5 -53 -14 -82 -25 -82
-10 0 -15 18 -24 84 -6 45 -5 43 -31 48 -17 3 -20 -3 -23 -42 -3 -65 -11 -90
-26 -90 -13 0 -26 48 -26 101 0 19 -6 28 -21 32 -20 6 -21 4 -14 -76z"/>
<path d="M2593 1910 c-18 -8 -43 -38 -43 -53 0 -3 11 -4 25 -4 14 0 25 5 25
13 0 7 4 16 10 19 14 9 45 -17 44 -35 -1 -8 -2 -20 -3 -26 0 -7 -19 -19 -40
-28 -47 -18 -64 -44 -63 -99 1 -52 30 -84 61 -68 25 14 27 27 6 35 -24 9 -21
102 4 116 27 14 32 2 30 -70 -2 -65 7 -85 34 -74 15 5 17 24 17 129 0 97 -3
125 -15 135 -19 16 -64 21 -92 10z m97 -70 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4
10 3 6 8 10 11 10 2 0 4 -4 4 -10z"/>
<path d="M3002 1909 c-18 -7 -42 -37 -42 -53 0 -13 48 -5 54 9 3 8 15 15 26
15 18 0 21 -5 18 -37 -3 -31 -8 -38 -35 -47 -43 -14 -62 -43 -63 -89 0 -47 15
-77 38 -77 30 0 44 21 28 39 -32 36 -17 121 21 121 12 0 14 -14 12 -70 -4 -74
4 -93 36 -84 18 5 20 15 22 117 2 95 -1 116 -16 136 -19 25 -61 34 -99 20z"/>
<path d="M3350 1913 c-33 -6 -50 -21 -50 -44 0 -23 35 -26 44 -4 10 26 43 18
49 -12 7 -36 4 -40 -49 -64 -24 -12 -44 -24 -45 -28 0 -3 -3 -17 -5 -31 -13
-67 26 -128 60 -94 14 14 14 17 1 30 -18 18 -20 95 -3 112 7 7 17 8 28 2 13
-7 16 -21 14 -67 -3 -68 5 -88 33 -79 17 5 19 18 21 122 2 110 1 116 -23 140
-24 24 -29 25 -75 17z"/>
<path d="M3690 1798 c0 -130 4 -149 32 -167 16 -10 23 -10 38 4 13 12 23 13
42 6 43 -16 47 -4 46 137 l0 132 -24 0 c-24 0 -24 -1 -24 -99 0 -117 -11 -157
-38 -142 -16 8 -18 19 -14 70 2 33 1 85 -3 116 -6 50 -9 55 -31 55 -24 0 -24
0 -24 -112z m127 0 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z"/>
<path d="M1161 1787 c-34 -17 -52 -81 -34 -125 14 -34 42 -43 62 -18 9 10 8
16 -4 26 -20 17 -20 88 2 112 19 21 8 23 -26 5z"/>
</g>
</svg>





    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
